import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import { map } from 'rxjs/operators';
var ProcessService = /** @class */ (function (_super) {
    tslib_1.__extends(ProcessService, _super);
    function ProcessService(http) {
        var _this = _super.call(this, http, MapperService.processMap) || this;
        _this._endpoint = 'odata/Releases';
        _this.suggest = function (searchTerm, fetchSize, skip) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            var queryOptions = {
                select: ['Id', 'EnvironmentId', 'Name', 'Key', 'Arguments', 'InputArguments'],
                orderBy: ['Name'],
                top: fetchSize,
                skip: skip,
                filter: {
                    Name: {
                        contains: searchTerm,
                    },
                },
            };
            return _this.get(queryOptions)
                .pipe(map(function (_a) {
                var data = _a.data, total = _a.total;
                return ({
                    total: total,
                    data: data.map(function (process) { return ({
                        id: process.id,
                        text: process.name,
                        data: process,
                    }); }),
                });
            }));
        };
        _this.suggestName = function (searchTerm, fetchSize, skip) {
            if (searchTerm === void 0) { searchTerm = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            return _this.suggest(searchTerm, fetchSize, skip)
                .pipe(map(function (_a) {
                var data = _a.data, total = _a.total;
                return ({
                    total: total,
                    data: data.map(function (process) { return ({
                        id: process.text,
                        text: process.text,
                    }); }),
                });
            }));
        };
        return _this;
    }
    ProcessService.prototype.updateReleaseToSpecificVersion = function (processId, packageVersion) {
        var payload = JSON.stringify({
            packageVersion: packageVersion,
        });
        return this._http.post(this._endpoint + "(" + processId + ")/UiPath.Server.Configuration.OData.UpdateToSpecificPackageVersion", payload);
    };
    ProcessService.prototype.updateReleaseToLatestVersion = function (processId) {
        return this._http.post(this._endpoint + "(" + processId + ")/UiPath.Server.Configuration.OData.UpdateToLatestPackageVersion", null);
    };
    ProcessService.prototype.updateReleasesToLatestVersionBulk = function (processIds) {
        return this._http.post(this._endpoint + "/UiPath.Server.Configuration.OData.UpdateToLatestPackageVersionBulk", { releaseIds: processIds });
    };
    ProcessService.prototype.rollbackReleaseToPreviousVersion = function (processIds) {
        return this._http.post(this._endpoint + "(" + processIds + ")/UiPath.Server.Configuration.OData.RollbackToPreviousReleaseVersion", null);
    };
    return ProcessService;
}(ODataService));
export { ProcessService };
